import { Check, Globe } from "lucide-react";
import { useLanguages } from "@/hooks/use-languages";
import { cn } from "@/lib/utils";
import { PickerButton } from "../ui/picker-button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  MENU_CONTENT,
  MENU_ITEM,
} from "../ui/dropdown-menu";

/**
 * `button` sits in the panel header; `badge` marks a localized field and opens the same
 * menu, so the language can be switched where the field is edited.
 */
export const EntityInstanceLanguageSelect = ({
  variant = "button",
}: {
  variant?: "button" | "badge";
}) => {
  const { languages, selectedLanguage, setSelectedLanguage } = useLanguages();
  const locale = selectedLanguage?.locale?.toLocaleUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <PickerButton
          icon={Globe}
          label={locale}
          size={variant === "button" ? "sm" : "xs"}
          // Keeps the field's label row at its normal height.
          className={variant === "badge" ? "-my-0.5" : undefined}
          aria-label="Editing language"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className={cn(MENU_CONTENT, "max-h-80 overflow-y-auto")}>
        {languages.map((language) => (
          <DropdownMenuItem
            key={language.id}
            className={MENU_ITEM}
            onSelect={() => setSelectedLanguage(language)}
          >
            <Check className={cn(language.locale !== selectedLanguage?.locale && "opacity-0")} />
            <span className="flex-1">{language.name}</span>
            <span className="text-xs font-normal text-muted-foreground">
              {language.locale?.toLocaleUpperCase()}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
